import * as React from 'react';
import { BasicContainer } from '../../shared/BasicContainer';
import styles from './DefaultAreaSkin.scss';
const DefaultAreaSkin = (props, ref) => {
    return React.createElement(BasicContainer, Object.assign({ ref: ref }, props, { classes: styles }));
};
export default React.forwardRef(DefaultAreaSkin);
//# sourceMappingURL=DefaultAreaSkin.skin.js.map